package com.dotpx.ambient

/** Exact SplitMix64 using Int limbs; hot sample calls allocate no boxed Longs. */
internal actual class SplitMix64 actual constructor(seed: ULong) {
    private var stateLow = seed.toInt()
    private var stateHigh = (seed shr 32).toInt()
    private var low = 0
    private var high = 0

    actual fun reset(seed: ULong) {
        stateLow = seed.toInt()
        stateHigh = (seed shr 32).toInt()
    }

    private fun advance() {
        val previous = stateLow
        stateLow += 0x7F4A7C15
        stateHigh += 0x9E3779B9.toInt()
        if ((stateLow xor Int.MIN_VALUE) < (previous xor Int.MIN_VALUE)) stateHigh += 1
        low = stateLow
        high = stateHigh
        xorShift(30)
        multiply(0x1CE4E5B9, 0xBF58476D.toInt())
        xorShift(27)
        multiply(0x133111EB, 0x94D049BB.toInt())
        xorShift(31)
    }

    private fun xorShift(bits: Int) {
        low = low xor ((low ushr bits) or (high shl (32 - bits)))
        high = high xor (high ushr bits)
    }

    private fun multiply(multiplierLow: Int, multiplierHigh: Int) {
        val a0 = low and 0xFFFF
        val a1 = low ushr 16
        val b0 = multiplierLow and 0xFFFF
        val b1 = multiplierLow ushr 16
        val p0 = a0 * b0
        val p1 = a1 * b0 + (p0 ushr 16)
        val p2 = a0 * b1 + (p1 and 0xFFFF)
        high = high * multiplierLow + low * multiplierHigh + a1 * b1 +
            (p1 ushr 16) + (p2 ushr 16)
        low = (p2 shl 16) or (p0 and 0xFFFF)
    }

    actual fun nextULong(): ULong {
        advance()
        return (high.toUInt().toULong() shl 32) or low.toUInt().toULong()
    }

    actual fun nextUnitDouble(): Double {
        advance()
        val unsignedHigh = (high ushr 1).toDouble() * 2.0 + (high and 1)
        return (unsignedHigh * 2_097_152.0 + (low ushr 11)) / 9_007_199_254_740_992.0
    }

    actual fun nextUnitFloat(): Float {
        advance()
        return (high ushr 8).toFloat() / 16_777_216f
    }

    actual fun nextBipolarFloat(): Float = nextUnitFloat() * 2f - 1f
}
